import { apirc } from '~/configs/apirc';
import { fetchDate } from './dateUtils';
export const fetchVolResult = async (startDate) => {
    return fetch(`${apirc.unclassified.tradeInfoURL}?type=vol&date=` + fetchDate(startDate).format('YYYY-MM-DD')).then(response => response.json());
};
export const fetchAmpResult = async (startDate) => {
    return fetch(`${apirc.unclassified.tradeInfoURL}?type=amp&date=` +
        fetchDate(startDate).format('YYYY-MM-DD').toString()).then(response => response.json());
};
